'use strict';


import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import UAParser from 'ua-parser-js';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';

import 'ng-juxtapose';
import 'angular-canvas-ext';
import 'angular-ui-switch';
import 'crypto-js';
import 'ng-toast';
import 'ngstorage';
import 'angularjs-slider';
import 'openseadragon';
import 'ng-openseadragon';
import 'jquery-mousewheel';
import 'malihu-custom-scrollbar-plugin';
import 'ng-scrollbars';

import {
  routeConfig
} from './app.config';

// Global components
import bodyCtrl from './body/body.component';
import navbar from '../components/navbar/navbar.component';
import _Auth from '../components/auth/auth.module';
import constants from './app.constants';

// Views
import accountView from './account';
import homeView from './home/home.component';
import viewpointsView from './viewpoints/viewpoints.component';


// Filters
import capitalizeFilter from '../components/filters/capitalize/capitalize.filter';
// Utilities and services

import util from '../components/util/util.module';
import Sites from '../components/Sites/Sites.service';
import Users from '../components/Users/Users.service';
import FilesUtil from '../components/Files/FilesUtil.service';
import Files from '../components/Files/Files.service';
import Errors from '../components/Errors/Errors.service';
import ViewpointManager from '../components/Viewpoint/viewpoint.service';
import TranslationManager from '../components/translation/translation.service';
import Modal from '../components/modal/modal.service';
import Progress from '../components/Progress/progress.service';
import Wistia from '../components/Wistia/Wistia.service';

// Directives
import mapPin from '../components/directives/mapPin/mapPin.directive';
import translate from '../components/directives/translate/translate.directive';
import ngLoad from '../components/directives/onLoad/onload.directive';
import passwordMatch from '../components/directives/passwordMatch/passwordMatch.directive';
import progressBar from '../components/directives/progressBar/progressBar.directive';
import slideable from '../components/directives/slidable/slidable.directive';
import lazyLoad from '../components/directives/lazyLoad/lazyLoad.directive';

import './app.scss';

angular.module('fplTruescapeComApp', [
  ngCookies, ngResource, ngSanitize, uiRouter, 'rzModule',
  uiBootstrap, _Auth, bodyCtrl, ngAnimate, accountView, lazyLoad,
  navbar, homeView, constants, util, Sites, TranslationManager,
  translate, viewpointsView, mapPin, capitalizeFilter, ViewpointManager, 'ngScrollbars',
  'ngJuxtapose', Modal, FilesUtil, Files, Errors, Users, progressBar, 'ui.openseadragon',
  'ap.canvas.ext', 'uiSwitch', Progress, 'ngToast', ngLoad, passwordMatch, slideable, 'ngStorage', Wistia
])
  .config(routeConfig)
  /* modify the ui-tooltip. both out tooltips do not show on
  hover when on mobile devices however they are triggered
  when on desktop */
  .config(['$uibTooltipProvider', $uibTooltipProvider => {
    let parser = new UAParser();
    let result = parser.getResult();
    let touch = result.device && (result.device.type === 'tablet' || result.device.type === 'mobile');
    if(touch) {
      // dont trigger if touch on mobile
      $uibTooltipProvider.options({trigger: 'dontTrigger'});
    } else {
      // trigger on mouse enter on desktop
      $uibTooltipProvider.options({trigger: 'mouseenter'});
    }
  }])
  .config(['ngToastProvider', 'appConfig', 'ScrollBarsProvider', function(ngToastProvider, appConfig, ScrollBarsProvider) {
    ScrollBarsProvider.defaults = {
      scrollButtons: {
        scrollAmount: 'auto', // scroll amount when button pressed
        enable: true // enable scrolling buttons by default
      },
      // alwaysShowScrollbar: 1,
      scrollbarPosition: 'outside',
      autoHideScrollbar: false,
      axis: 'y' // enable 2 axis scrollbars by default
    };
    ngToastProvider.configure({
      animation: 'slide',
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      maxNumber: 1,
      combineDuplications: false
    });
  }])
  .run(function($rootScope, $location, $state, $window, Auth) {
    'ngInject';
    // assign mapboxgl to window so we can use it in other components,
    // for some reason it's not globally available otherwise.
    // Redirect to login if route requires auth and you're not logged in
    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {
          // Stop the state change from continuing, kill the session and redirect to login.
          event.preventDefault();
          Auth.logout();
          $window.location.assign('/login');
        }
      });
    });
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['fplTruescapeComApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js